<template>
<div class="chapter">
<div class="inner_page">
<div id="contents">
<div class="story">
<p class="x2fm-ttl"><span class="bold">Contents</span></p>
<div class="contentsEntry" id="dedication">
<p class="x2toc"><em class="italic"><span href="#/text/9780062030580_Dedication" title="Link target outside of Sample">Dedication</span></em></p>
</div>
<div class="contentsEntry" id="prologue">
<p class="x2toc-after-txb1"><span class="generated-style"><a href="#/text/9780062030580_Prologue">Prologue</a></span></p>
</div>
<div class="contentsEntry" id="part-i">
<p class="x2toc-after-txb1"><span class="generated-style"><a href="#/text/9780062030580_Part_1#part-i">Part I</a></span></p>
</div>
<div class="contentsEntry" id="chapter-1">
<p class="x2toc">     <span class="generated-style"><a href="#/text/9780062030580_Chapter_1#chapter-1">Chapter 1</a></span></p>
</div>
<div class="contentsEntry" id="chapter-2">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_2#chapter-2" title="Link target outside of Sample">Chapter 2</span></span></p>
</div>
<div class="contentsEntry" id="chapter-3">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_3#chapter-3" title="Link target outside of Sample">Chapter 3</span></span></p>
</div>
<div class="contentsEntry" id="chapter-4">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_4#chapter-4" title="Link target outside of Sample">Chapter 4</span></span></p>
</div>
<div class="contentsEntry" id="chapter-5">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_5#chapter-5" title="Link target outside of Sample">Chapter 5</span></span></p>
</div>
<div class="contentsEntry" id="chapter-6">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_6#chapter-6" title="Link target outside of Sample">Chapter 6</span></span></p>
</div>
<div class="contentsEntry" id="chapter-7">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_7#chapter-7" title="Link target outside of Sample">Chapter 7</span></span></p>
</div>
<div class="contentsEntry" id="chapter-8">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_8#chapter-8" title="Link target outside of Sample">Chapter 8</span></span></p>
</div>
<div class="contentsEntry" id="chapter-9">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_9#chapter-9" title="Link target outside of Sample">Chapter 9</span></span></p>
</div>
<div class="contentsEntry" id="chapter-10">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_10#chapter-10" title="Link target outside of Sample">Chapter 10</span></span></p>
</div>
<div class="contentsEntry" id="chapter-11">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_11#chapter-11" title="Link target outside of Sample">Chapter 11</span></span></p>
</div>
<div class="contentsEntry" id="chapter-12">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_12#chapter-12" title="Link target outside of Sample">Chapter 12</span></span></p>
</div>
<div class="contentsEntry" id="chapter-13">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_13#chapter-13" title="Link target outside of Sample">Chapter 13</span></span></p>
</div>
<div class="contentsEntry" id="chapter-14">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_14#chapter-14" title="Link target outside of Sample">Chapter 14</span></span></p>
</div>
<div class="contentsEntry" id="chapter-15">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_15#chapter-15" title="Link target outside of Sample">Chapter 15</span></span></p>
</div>
<div class="contentsEntry" id="chapter-16">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_16#chapter-16" title="Link target outside of Sample">Chapter 16</span></span></p>
</div>
<div class="contentsEntry" id="chapter-17">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_17#chapter-17" title="Link target outside of Sample">Chapter 17</span></span></p>
</div>
<div class="contentsEntry" id="chapter-18">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_18#chapter-18" title="Link target outside of Sample">Chapter 18</span></span></p>
</div>
<div class="contentsEntry" id="chapter-19">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_19#chapter-19" title="Link target outside of Sample">Chapter 19</span></span></p>
</div>
<div class="contentsEntry" id="chapter-20">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_20#chapter-20" title="Link target outside of Sample">Chapter 20</span></span></p>
</div>
<div class="contentsEntry" id="chapter-21">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_21#chapter-21" title="Link target outside of Sample">Chapter 21</span></span></p>
</div>
<div class="contentsEntry" id="chapter-22">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_22#chapter-22" title="Link target outside of Sample">Chapter 22</span></span></p>
</div>
<div class="contentsEntry" id="chapter-23">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_23#chapter-23" title="Link target outside of Sample">Chapter 23</span></span></p>
</div>
<div class="contentsEntry" id="part-ii">
<p class="x2toc-after-txb1"><span class="generated-style"><span href="#/text/9780062030580_Part_2#part-ii" title="Link target outside of Sample">Part II</span></span></p>
</div>
<div class="contentsEntry" id="chapter-24">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_24#chapter-24" title="Link target outside of Sample">Chapter 24</span></span></p>
</div>
<div class="contentsEntry" id="chapter-25">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_25#chapter-25" title="Link target outside of Sample">Chapter 25</span></span></p>
</div>
<div class="contentsEntry" id="chapter-26">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_26#chapter-26" title="Link target outside of Sample">Chapter 26</span></span></p>
</div>
<div class="contentsEntry" id="chapter-27">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_27#chapter-27" title="Link target outside of Sample">Chapter 27</span></span></p>
</div>
<div class="contentsEntry" id="chapter-28">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_28#chapter-28" title="Link target outside of Sample">Chapter 28</span></span></p>
</div>
<div class="contentsEntry" id="chapter-29">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_29#chapter-29" title="Link target outside of Sample">Chapter 29</span></span></p>
</div>
<div class="contentsEntry" id="chapter-30">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_30#chapter-30" title="Link target outside of Sample">Chapter 30</span></span></p>
</div>
<div class="contentsEntry" id="chapter-31">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_31#chapter-31" title="Link target outside of Sample">Chapter 31</span></span></p>
</div>
<div class="contentsEntry" id="chapter-32">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_32#chapter-32" title="Link target outside of Sample">Chapter 32</span></span></p>
</div>
<div class="contentsEntry" id="chapter-33">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_33#chapter-33" title="Link target outside of Sample">Chapter 33</span></span></p>
</div>
<div class="contentsEntry" id="chapter-34">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_34#chapter-34" title="Link target outside of Sample">Chapter 34</span></span></p>
</div>
<div class="contentsEntry" id="chapter-35">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_35#chapter-35" title="Link target outside of Sample">Chapter 35</span></span></p>
</div>
<div class="contentsEntry" id="chapter-36">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_36#chapter-36" title="Link target outside of Sample">Chapter 36</span></span></p>
</div>
<div class="contentsEntry" id="chapter-37">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_37#chapter-37" title="Link target outside of Sample">Chapter 37</span></span></p>
</div>
<div class="contentsEntry" id="chapter-38">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_38#chapter-38" title="Link target outside of Sample">Chapter 38</span></span></p>
</div>
<div class="contentsEntry" id="chapter-39">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_39#chapter-39" title="Link target outside of Sample">Chapter 39</span></span></p>
</div>
<div class="contentsEntry" id="chapter-40">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_40#chapter-40" title="Link target outside of Sample">Chapter 40</span></span></p>
</div>
<div class="contentsEntry" id="chapter-41">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_41#chapter-41" title="Link target outside of Sample">Chapter 41</span></span></p>
</div>
<div class="contentsEntry" id="part-iii">
<p class="x2toc-after-txb1"><span class="generated-style"><span href="#/text/9780062030580_Part_3#part-iii" title="Link target outside of Sample">Part III</span></span></p>
</div>
<div class="contentsEntry" id="chapter-42">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_42#chapter-42" title="Link target outside of Sample">Chapter 42</span></span></p>
</div>
<div class="contentsEntry" id="chapter-43">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_43#chapter-43" title="Link target outside of Sample">Chapter 43</span></span></p>
</div>
<div class="contentsEntry" id="chapter-44">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_44#chapter-44" title="Link target outside of Sample">Chapter 44</span></span></p>
</div>
<div class="contentsEntry" id="chapter-45">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_45#chapter-45" title="Link target outside of Sample">Chapter 45</span></span></p>
</div>
<div class="contentsEntry" id="chapter-46">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_46#chapter-46" title="Link target outside of Sample">Chapter 46</span></span></p>
</div>
<div class="contentsEntry" id="chapter-47">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_47#chapter-47" title="Link target outside of Sample">Chapter 47</span></span></p>
</div>
<div class="contentsEntry" id="chapter-48">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_48#chapter-48" title="Link target outside of Sample">Chapter 48</span></span></p>
</div>
<div class="contentsEntry" id="chapter-49">
<p class="x2toc">     <span class="generated-style"><span href="#/text/9780062030580_Chapter_49#chapter-49" title="Link target outside of Sample">Chapter 49</span></span></p>
</div>
<div class="contentsEntry" id="epilogue">
<p class="x2toc"><span class="generated-style"><span href="#/text/9780062030580_Epilogue#epilogue" title="Link target outside of Sample">Epilogue</span></span></p>
</div>
<div class="contentsEntry" id="acknowledgments">
<p class="x2toc-after-txb1"><em class="italic"><span href="#/text/9780062030580_Acknowledgments#acknowledgments" title="Link target outside of Sample">Acknowledgments</span></em></p>
</div>
<div class="contentsEntry" id="about-the-author">
<p class="x2toc"><em class="italic"><span href="#/text/About_the_Author#about-the-author" title="Link target outside of Sample">About the Author</span></em></p>
</div>
<div class="contentsEntry" id="also-by-the-author">
<p class="x2toc"><em class="italic"><span href="#/text/9780062030580_AlsoBy#also-by-the-author" title="Link target outside of Sample">Also by Sandra Rodriguez Barron</span></em></p>
</div>
<div class="contentsEntry" id="credits">
<p class="x2toc"><em class="italic"><span href="#/text/9780062030580_Credits#credits" title="Link target outside of Sample">Credits</span></em></p>
</div>
<div class="contentsEntry" id="copyright">
<p class="x2toc"><em class="italic"><span href="#/text/9780062030580_Copyright#copyright" title="Link target outside of Sample">Copyright</span></em></p>
</div>
<div class="contentsEntry" id="atp_01">
<p class="x2toc"><em class="italic"><span href="#/text/About_the_Publisher#atp01" title="Link target outside of Sample">About the Publisher</span></em></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062030580_Contents.vue?1b78d0a6